import { useParams } from 'react-router-dom';

export function useCurrentPlatformId() {
  const { platformId } = useParams<{ platformId: string }>();
  if (!platformId) {
    throw new Error('No platform id provided');
  }
  return platformId;
}
